import React, { useEffect, useState, useCallback } from "react";
import MainLayout from "layout/MainLayout";
import useClient from "hooks/useClient";
import useSnackMsg from "hooks/useSnackMsg";
import UserCard from "components/UserCard";
import { RiseLoader } from "react-spinners";
import ReactPaginate from "react-paginate";
import Header from "components/Header";
import Modal from "components/common/Modal";
import LogsInfo from "components/LogsInfo";
import "./page.css";
import { useTheme } from 'components/common/ThemeContext';
import AnalyticCard from "components/AnalyticCard";



const Home = () => {
    const { api } = useClient();
    const { eSnack } = useSnackMsg();

    // State for user data
    const [usersData, setUsersData] = useState({
        users: [],
        current_page: 1,
        total_pages: 1,
    });
    const [loader, setLoader] = useState(false);
    const [analtticData, setAnalyticData] = useState({})

    // State for logs modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [logsLoader, setLogsLoader] = useState(false);
    const [logsData, setLogsData] = useState([]);
    const [userName, setUserName] = useState("")
    const { theme } = useTheme();

    // Fetch users from API
    const fetchUsers = useCallback(async (page = 1) => {
        setLoader(true);
        try {
            const response = await api.get(`/auth/get-all-users?page=${page}&size=10`);
            if (response.status === 200) {
                const { data } = response;
                setUsersData({
                    users: data.users || [],
                    current_page: page,
                    total_pages: data.total_pages || 1,
                });
            } else {
                eSnack(response.statusText || "An error occurred.");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            eSnack("Failed to fetch users. Please try again.");
        } finally {
            setLoader(false);
        }
    }, [api, eSnack]);

    // Fetch logs for a specific user
    const fetchLogs = async (userInfo) => {    
        setUserName("")
        if (!userInfo.id) return;
        setUserName(userInfo.username)
        setLogsData([])
        setLogsLoader(true);
        setIsModalOpen(true);
        try {
            const response = await api.get(`/logs/get-logs/${userInfo.id}`);
            if (response.status === 200) {
                setLogsData(response.data || []);
            } else {
                eSnack(response.statusText || "An error occurred.");
                setIsModalOpen(false);
            }
        } catch (error) {
            console.error("Error fetching logs:", error);
            eSnack("Failed to fetch logs. Please try again.");
            setIsModalOpen(false);
        } finally {
            setLogsLoader(false);
        }
    };

    // Pagination handler
    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1; // ReactPaginate uses 0-based index
        fetchUsers(newPage);
    };
    const handleAnalytic = () => {
        setLoader(true)
        api.get(`/auth/get-stats`).then((res) => {
            console.log("res", res.data)
            setLoader(false)
            setAnalyticData(res?.data)
        }).catch((err) => {
            setLoader(false)
            console.log("data", err)
        })
    }

    useEffect(() => {
        fetchUsers(); // Fetch initial user data
        handleAnalytic()
    }, []);

    return (
        <MainLayout>
            {/* <Header /> */}
            {/* Loader */}
            {loader && (
                <div className="mt-[100px] flex justify-center">
                    <RiseLoader color={theme ==='dark' ?"#ffffff" :"#000"} size={36} />
                </div>
            )}
            {!loader && (
            <div className="grid xs:grid-col-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 p-4">
                <div className="col-span-1">
                    <AnalyticCard index={1} title="Total Registered users" value={`${analtticData?.total_registered_users}`} />
                </div>
                <div className="col-span-1">
                    <AnalyticCard index={2} title="Average Subtasks" value={`${analtticData?.average_subtasks}`} />
                </div>
                <div className="col-span-1">
                    <AnalyticCard index={3} title="Average time taken" value={`${analtticData?.average_time_taken} Secs`} />
                </div>
                <div className="col-span-1">
                    <AnalyticCard index={4} title="Average Success Rates"  value={`${analtticData?.average_success_rate}%`} />
                </div>
            </div>
            )}
            {/* User List */}
            {!loader && usersData.users.length > 0 ? (
                <div className="grid xs:grid-cols-4 sm:grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-5 p-4">
                    {usersData.users.map((user, index) => (
                        <div
                            key={index}
                            className="col-span-4"
                        >
                            <UserCard userInfo={user} onLogs={() => fetchLogs(user)} />
                        </div>
                    ))}
                </div>
            ) : (
                !loader && <p className="text-center font-bold text-[16px] mt-[100px]">No users found.</p>
            )}

            {/* Pagination */}
            {!loader && usersData.total_pages > 1 && (
                <div className="flex justify-center mt-8">
                    <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={usersData.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        forcePage={usersData.current_page - 1}
                        containerClassName="custom-pagination"
                        pageClassName="custom-page"
                        activeClassName="custom-active"
                        previousClassName="custom-prev"
                        nextClassName="custom-next"
                        breakClassName="custom-break"
                    />
                </div>
            )}

            {/* Logs Modal */}
            {isModalOpen && (
                <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} 
                title={!logsLoader && userName ? `${userName} Details` : `User Details`}>
                    {logsLoader ? (
                        <div className="flex justify-center py-4">
                            <RiseLoader color={theme ==='dark' ?"#ffffff" :"#000"} size={24} />
                        </div>
                    ) : logsData.length > 0 ? (
                        <div className="grid grid-cols-1 gap-4">
                            {logsData.map((log, index) => (
                                <div key={index} className="col-span-1 ">
                                    <LogsInfo data={log} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-center font-Inter dark:text-white font-bold text-[16px]">No logs found.</p>
                    )}
                </Modal>
            )}
        </MainLayout>
    );
};

export default Home;
